import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { CountryMap } from '@chegg/commerce-utils';
import { selectedCity, setCityFlags } from '../../redux/UserAddressState/UserAddressState.slice';
import { strings } from '../../constants/strings';
export var displayCityAddress = function displayCityAddress(address) {
  var cityAddress = '';
  var city = address.city,
    stateAbbreviation = address.state_abbreviation,
    state = address.state;
  if (city) cityAddress += "".concat(city);
  if (stateAbbreviation) {
    cityAddress += city ? ", ".concat(stateAbbreviation) : "".concat(stateAbbreviation);
  } else if (state) {
    cityAddress += city ? ", ".concat(state) : "".concat(state);
  }
  return cityAddress;
};
export var selectItem = function selectItem(item, dispatch) {
  dispatch(selectedCity(_objectSpread({}, item)));
  dispatch(setCityFlags({
    showAddress: true,
    showSuggestions: false,
    error: false
  }));
};
export var getZipCodeValidationText = function getZipCodeValidationText(zip, zipField) {
  if (zip.error) {
    var _zipField$errors;
    return (zipField === null || zipField === void 0 || (_zipField$errors = zipField.errors) === null || _zipField$errors === void 0 ? void 0 : _zipField$errors.required) || zip.error;
  }
  if (zip.invalid) {
    var _zipField$errors2;
    return (zipField === null || zipField === void 0 || (_zipField$errors2 = zipField.errors) === null || _zipField$errors2 === void 0 ? void 0 : _zipField$errors2.invalid) || strings['APP.ZIPCODE.ERROR.INVALID'];
  }
  return '';
};
export var getCityValidationText = function getCityValidationText(cityField) {
  var _cityField$errors;
  return (cityField === null || cityField === void 0 || (_cityField$errors = cityField.errors) === null || _cityField$errors === void 0 ? void 0 : _cityField$errors.required) || strings['APP.CITY.ERROR'];
};
export var getZipInputMode = function getZipInputMode(countryCode) {
  var _CountryMap$get;
  return (_CountryMap$get = CountryMap.get(countryCode)) !== null && _CountryMap$get !== void 0 && _CountryMap$get.isZipNumeric ? 'numeric' : 'text';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/internal/ZipcodeField/helpers.js
// module id = 4517
// module chunks = 11